import "../../styles/strategiesInfo.css";

export default function StrategyDetailsInfo({ onClose }) {
  return (
    <div className="info-backdrop" onClick={onClose}>
      <div className="info-modal" onClick={e => e.stopPropagation()}>

        <button className="info-close" onClick={onClose}>✕</button>

        <h2>Stratégia részletek</h2>

        <p>
          Ez az oldal egy adott <strong>fogadási stratégia</strong> nyomon követésére szolgál.
          Itt tudod rögzíteni az egyes szelvényeket, majd valós adatok alapján elemezni,
          hogy hosszú távon mennyire működik a stratégiád.
        </p>

        <p>
          Minden szelvénynél megadhatod a <strong>tétet</strong>, az <strong>oddsot</strong> és az
          <strong> eredményt</strong>. Ezekből az adatokból a rendszer automatikusan statisztikákat
          készít.
        </p>

        <ul>
          <li>✔ Szelvények rögzítése és visszanézése</li>
          <li>✔ Találati arány, profit és teljesítmény statisztikák</li>
          <li>✔ Stratégiák objektív összehasonlítása</li>
        </ul>

        <p className="info-note">
          💡 Tipp: Ne csak a nyertes szelvényeket rögzítsd – a vesztesek mutatják meg igazán,
          hogy működik-e a stratégia hosszú távon.
        </p>



      </div>
    </div>
  );
}
